import { RootState } from 'store';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { STATIONS_STATE } from '../../constants';

export const useVisibleStations = () => {
  return useSelector((state: RootState) => state[STATIONS_STATE].visibleStations.data);
};

export const useShowVisibleStations = () => {
  return useSelector((state: RootState) => state[STATIONS_STATE].visibleStations.show) ?? true;
};

export const useVisibleStationsAmount = () => {
  const visibleStations = useVisibleStations();

  return useMemo(() => (visibleStations || []).length, [visibleStations]);
};
